export const checkifUserExists = (email, fullName, companyName) => {
  return (dispatch, getState, { api }) => {
    return api.checkifUserExists(email, fullName, companyName).then(
      (data) => {
        // Set onedotcomac cookie if user exists for marketing usage
        if (data.result) {
          document.cookie = `onedotcomac=true;path=/;domain=.one.com;expires=${new Date(new Date().setFullYear(new Date().getFullYear() + 1))};`;

          return {
            wasSuccessful: true,
            isUserExist: data.result.exists,
          };
        } else {
          return { wasSuccessful: false };
        }
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
